<template>
  <div class="content-studio" dir="rtl">
    <div class="content-studio__ambient" aria-hidden="true"></div>

    <div class="content-studio__shell">
      <header class="studio-topbar">
        <div class="studio-topbar__copy">
          <p class="studio-eyebrow">{{ form.content_type == 1 ? 'مدیریت پست‌ها' : (form.content_type == 0 ? 'مدیریت برگه‌ها' : 'مدیریت محتوا') }}</p>
          <h1 class="studio-title">{{ title }}</h1>
        </div>

        <nav class="studio-topbar__actions" v-if="this.$route.params.slug !== undefined">
          <router-link v-if="form.content_type==1" :to="{ name: 'PostsDashboard' }" class="studio-chip">
            <b-icon icon="arrow-right"/> بازگشت به صفحه پست ها
          </router-link>
          <router-link v-if="form.content_type==0" :to="{ name: 'PagesDashboard' }" class="studio-chip">
            <b-icon icon="arrow-right"/> بازگشت به صفحه برگه ها
          </router-link>
        </nav>
      </header>

      <b-form class="studio-form" @submit.prevent="onSubmit">
        <div class="studio-layout">
          <div class="studio-main">
            <!-- Basics -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <div>
                  <h2 class="studio-panel__title">
                    <span class="studio-panel__title-icon"><b-icon icon="card-heading"/></span>
                    اطلاعات پایه
                  </h2>
                  <p class="studio-panel__hint">عنوان و لینک محتوا</p>
                </div>
                <span class="studio-step">۱</span>
              </div>
              <div class="studio-panel__body" :class="{ 'studio-basics--with-thumb': isMobileLayout }">
                <div v-if="isMobileLayout" class="studio-title-thumb studio-image">
                  <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                                :validation="$v.form.mainImage" @input="onMainImagePicked"></single-image>
                </div>
                <div class="studio-basics__fields">
                <name-and-link-manager v-if="form.content_type == 1"
                                       :router-link="{ name: 'SinglePost', params: { slug: form.titleAndSlug.link } }"
                                       :label="'عنوان'"
                                       v-model="form.titleAndSlug"
                                       :validation="$v.form.titleAndSlug.name"/>

                <name-and-link-manager v-else
                                       :router-link="{ name: 'SinglePage', params: { slug: form.titleAndSlug.link } }"
                                       :label="'عنوان'"
                                       v-model="form.titleAndSlug"
                                       :validation="$v.form.titleAndSlug.name"/>
                </div>
              </div>
            </section>

            <!-- Abstraction -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <div>
                  <h2 class="studio-panel__title">
                    <span class="studio-panel__title-icon"><b-icon icon="text-paragraph"/></span>
                    چکیده
                  </h2>
                  <p class="studio-panel__hint">خلاصه‌ای کوتاه که در فهرست‌ها نمایش داده می‌شود</p>
                </div>
                <span class="studio-step">۲</span>
              </div>
              <div class="studio-panel__body">
                <form-group :validations="$v.form.abstraction" class="w-100">
                  <div slot-scope="{ errors, invalid }">
                    <div class="studio-editor">
                      <div class="studio-editor__canvas">
                        <vue2-tinymce-editor v-model="form.abstraction" :options="defaultToolbar"></vue2-tinymce-editor>
                      </div>
                    </div>
                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>
              </div>
            </section>

            <!-- Body -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <div>
                  <h2 class="studio-panel__title">
                    <span class="studio-panel__title-icon"><b-icon icon="file-richtext"/></span>
                    متن
                  </h2>
                  <p class="studio-panel__hint">متن اصلی، مدیا، iframe و کامپوننت‌ها</p>
                </div>
                <span class="studio-step">۳</span>
              </div>
              <div class="studio-panel__body">
                <form-group :validations="$v.form.body" class="w-100">
                  <div slot-scope="{ errors, invalid }">
                    <div class="studio-editor">
                      <div class="studio-editor__bar">
                        <span class="studio-editor__bar-label">ابزارها</span>
                        <add-iframe-to-editor class="iframe-editor-tool" @iframe-handler="iframeHandlerFunction"/>
                      </div>
                      <div class="studio-editor__canvas content-editor">
                  <published-checkbox label="ادیتور پیشرفته" v-model="form.editor_mode"/>
                  <div class="content-editor__tools">
                    <div class="text-right">
                      <b-button class="mx-3 mb-2" v-b-modal.modal-xl> اضافه کردن مدیا</b-button>

                      <b-modal id="modal-xl"
                               title=""
                               centered
                               hide-footer
                               content-class=""
                               size="xl"


                      >
                        <file-manager @file-selected="insertFileInEditor"/>
                      </b-modal>

                      <b-button class="mx-3 mb-2" @click="resetModal" v-b-modal.add-component>اضافه کردن کامپوننت</b-button>

                      <b-modal id="add-component"
                               ref="add-component"
                               title=""
                               centered
                               hide-footer
                               content-class=""
                               size="xl">

                        <div class="text-right" dir="rtl">

                          <span class="mb-0">انتخاب کامپوننت</span>
                          <select class="form-control px-4 my-4"
                                  v-model="selected_component">
                            <option v-for="item in editor_components" :value="item">{{
                                item.name
                              }}
                            </option>
                          </select>


                          <div class="">
                            <div v-for="(item,key) in selectedComponentProps()">

                              <div class="form-group" v-if="item['type'] == 'Array' && item['source'] == 'file-manager'">
                                <label for="">{{ key }}</label>
                                <b-button class="mx-3 mb-2 d-block" @click="setModalItem(key)"
                                          v-b-modal.add-material-to-component>
                                  اضافه کردن عکس
                                </b-button>

                                <div class="m-3 d-inline-block text-center" v-for="(arrayItem,index) in item['default']">
                                  <img class="d-inline-block rounded mx-1"
                                       :src="arrayItem['image']" style="width: 150px;height: 150px;object-fit: contain"
                                       :alt="arrayItem['alt']">
                                  <input class="form-control my-2" type="text" v-model="arrayItem['alt']">
                                  <div class="d-flex justify-content-center">
                                    <b-icon @click="moveItem(item['default'],index,'up')" icon="chevron-right"
                                            class="mx-4 h5  "/>
                                    <b-icon @click="moveItem(item['default'],index,'down')" icon="chevron-left"
                                            class="mx-4  h5 "/>
                                    <b-icon @click="removeItem(item['default'],index)" icon="trash"
                                            class="mx-4  h5 "/>

                                  </div>
                                </div>

                              </div>
                              <div class="form-group" v-else>
                                <label for="">{{ key }}</label>
                                <input type="text" v-model="item['default']" class="form-control">
                              </div>
                            </div>
                          </div>


                          <b-modal id="add-material-to-component"
                                   title=""
                                   centered
                                   hide-footer
                                   content-class=""
                                   size="xl">
                            <file-manager @file-selected="setValueOfImage"/>
                          </b-modal>


                          <div class="text-center">
                            <button @click="submitComponent" class="btn btn-primary w-75">ثبت</button>
                          </div>


                        </div>
                      </b-modal>
                    </div>
                  </div>

                  <vue2-tinymce-editor v-model="form.body" :options="defaultToolbar"
                                       id="main-editor"
                                       ref="tinymceEditor"></vue2-tinymce-editor>
                      </div>
                    </div>
                    <form-errors-manager :errors="errors"/>
                  </div>
                </form-group>
              </div>
            </section>

            <!-- SEO -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <div>
                  <h2 class="studio-panel__title">
                    <span class="studio-panel__title-icon"><b-icon icon="search"/></span>
                    سئو و کلمات کلیدی
                  </h2>
                  <p class="studio-panel__hint">کلمات کلیدی مرتبط با این محتوا</p>
                </div>
                <span class="studio-step">۴</span>
              </div>
              <div class="studio-panel__body content-keywords">
                <div class="kw-input" @click="$refs.keywordInput && $refs.keywordInput.focus()">
                  <span class="kw-chip" v-for="(word, index) in form.keyWords" :key="'kw-' + index + '-' + word">
                    {{ word }}
                    <button type="button" class="kw-chip__x" @click.stop="removeKeyword(index)" aria-label="حذف">
                      <b-icon icon="x"/>
                    </button>
                  </span>
                  <input ref="keywordInput" v-model="keywordDraft" class="kw-input__field"
                         :placeholder="form.keyWords.length ? 'کلمه بعدی...' : 'کلمه کلیدی را بنویسید...'"
                         @keydown.enter.prevent="addKeywords(keywordDraft)"
                         @keydown.backspace="onKeywordBackspace"
                         @input="onKeywordInput"
                         @blur="addKeywords(keywordDraft)">
                </div>
                <small class="kw-help">با Enter یا ویرگول (,) اضافه کنید. برای حذف روی × بزنید.</small>
              </div>
            </section>
          </div>

          <aside class="studio-side">
            <!-- Publish -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <h2 class="studio-panel__title">
                  <span class="studio-panel__title-icon"><b-icon icon="broadcast"/></span>
                  انتشار
                </h2>
              </div>
              <div class="studio-panel__body">
                <div class="studio-status-row" :class="{ 'is-on': form.status }">
                  <div class="studio-status-row__text">
                    <span class="studio-status-row__label">وضعیت انتشار</span>
                    <span class="studio-status-row__state">
                      <span class="studio-status-row__dot"></span>
                      {{ form.status ? 'منتشر شده' : 'پیش‌نویس' }}
                    </span>
                  </div>
                  <button type="button" role="switch" class="studio-switch" :class="{ 'is-on': form.status }"
                          :aria-checked="form.status ? 'true' : 'false'" @click="form.status = !form.status">
                    <span class="studio-switch__knob"></span>
                  </button>
                </div>

                <label class="studio-label mt-3">نوع محتوا</label>
                <div class="studio-segment" role="radiogroup">
                  <button v-for="item in content_typeList" :key="item.id" type="button" class="studio-segment__btn"
                          :class="{ 'is-active': form.content_type !== '' && form.content_type !== null && form.content_type == item.id }"
                          @click="setContentType(item.id)">
                    <b-icon :icon="item.id == 1 ? 'newspaper' : 'file-earmark-text'"/>
                    {{ item.name }}
                  </button>
                </div>
                <small class="studio-field-error" v-if="$v.form.content_type.$error">نوع محتوا را انتخاب کنید.</small>
                <!-- kept for setContent() (#item_{id}.click()) compatibility -->
                <div class="d-none">
                  <radio-box :label="'انتخاب نوع محتوا'" :radioItems="content_typeList" v-model="form.content_type"
                             :validation="$v.form.content_type" :isBrand="false"/>
                </div>
                <label class="studio-label mt-3">تاریخ و ساعت انتشار</label>
                <date-picker
                    auto-submit
                    append-to="body"
                    v-model="form.created_at"
                    type="datetime"
                    class="datetime-input w-100"
                    format="YYYY-MM-DD HH:mm:ss"
                    display-format="jYYYY/jMM/jDD HH:mm:ss"
                    placeholder="تاریخ و ساعت را انتخاب کنید"
                />

                <template v-if="$route.params.slug != undefined">
                  <button type="button" class="studio-ghost-btn mt-3"
                          @click="copyToClipBoard(`${findAttributeOnSiteInfo('host')[0]}/api/s/c-${form.id}`)">
                    <b-icon-link45deg/> کپی لینک کوتاه
                  </button>
                  <div class="studio-qr-card mt-3">
                    <qr-generator
                        :qr-value="dashboardLinkToSiteLink(contentType(),{slug:form.titleAndSlug.link})"/>
                  </div>
                </template>
              </div>
            </section>

            <!-- Image (on mobile it is shown beside the title instead) -->
            <section class="studio-panel" v-if="!isMobileLayout">
              <div class="studio-panel__head">
                <h2 class="studio-panel__title">
                  <span class="studio-panel__title-icon"><b-icon icon="image"/></span>
                  تصویر شاخص
                </h2>
              </div>
              <div class="studio-panel__body studio-image">
                <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                              :validation="$v.form.mainImage" @input="onMainImagePicked"></single-image>
              </div>
            </section>

            <!-- Language -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <h2 class="studio-panel__title">
                  <span class="studio-panel__title-icon"><b-icon icon="translate"/></span>
                  زبان
                </h2>
              </div>
              <div class="studio-panel__body studio-side__boxes">
                <languageBox v-model="form.language_id" :validation="$v.form.language_id"/>
              </div>
            </section>

            <!-- Categories -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <h2 class="studio-panel__title">
                  <span class="studio-panel__title-icon"><b-icon icon="folder2-open"/></span>
                  دسته‌بندی
                </h2>
                <button type="button" class="studio-head-btn" v-b-modal.create-content-category>
                  <b-icon icon="plus-lg"/> دسته جدید
                </button>
              </div>
              <div class="studio-panel__body">
                <div class="studio-chips" v-if="form.selectedCategory.length">
                  <span class="studio-chip-tag" v-for="(item, index) in form.selectedCategory" :key="'sc-' + item.id">
                    {{ item.name }}
                    <button type="button" class="studio-chip-tag__x" @click="form.selectedCategory.splice(index, 1)"
                            aria-label="حذف"><b-icon icon="x"/></button>
                  </span>
                </div>
                <div class="studio-search">
                  <b-icon icon="search" class="studio-search__icon"/>
                  <input v-model="categorySearch" class="studio-search__input" placeholder="جستجوی دسته‌بندی...">
                  <button type="button" class="studio-search__action" v-b-tooltip.hover title="بروزرسانی"
                          @click="refreshCategories"><b-icon icon="arrow-clockwise"/></button>
                </div>
                <div class="studio-picklist">
                  <label v-for="row in categoryRows" :key="'cat-' + row.item.id" class="studio-pick"
                         :class="{ 'is-checked': isCategorySelected(row.item) }"
                         :style="{ paddingRight: (0.6 + row.depth * 1.1) + 'rem' }">
                    <input type="checkbox" class="studio-pick__check" :checked="isCategorySelected(row.item)"
                           @change="toggleCategory(row.item)">
                    <span class="studio-pick__box"><b-icon icon="check"/></span>
                    <span class="studio-pick__name">{{ row.item.name }}</span>
                    <span class="studio-pick__sub" v-if="row.hasChildren">زیردسته</span>
                  </label>
                  <p class="studio-picklist__empty" v-if="!categoryRows.length">دسته‌بندی‌ای یافت نشد.</p>
                </div>
                <small class="studio-field-error" v-if="$v.form.selectedCategory.$error">حداقل یک دسته‌بندی انتخاب کنید.</small>

                <b-modal
                    id="create-content-category"
                    title="افزودن دسته‌بندی"
                    size="lg"
                    hide-footer
                    centered
                    @show="snapshotCategoryIds">
                  <div class="studio-category-modal" dir="rtl">
                    <p class="studio-category-modal__hint">
                      دسته اصلی یا زیردسته جدید بسازید. برای زیردسته، دسته والد را انتخاب کنید.
                    </p>
                    <quick-category-create @created="onContentCategoryCreated"/>
                  </div>
                </b-modal>
              </div>
            </section>

            <!-- Authors -->
            <section class="studio-panel">
              <div class="studio-panel__head">
                <h2 class="studio-panel__title">
                  <span class="studio-panel__title-icon"><b-icon icon="people"/></span>
                  نویسندگان
                </h2>
              </div>
              <div class="studio-panel__body">
                <label class="studio-label">نویسنده</label>
                <UserFilter2 :roles="[1,2,3,4]" @change_user="setAuthor" :user="form.author"/>

                <label class="studio-label mt-3">نویسندگان همکار</label>
                <div class="studio-chips" v-if="coAuthors.length">
                  <span class="studio-person-chip" v-for="user in coAuthors" :key="'co-' + user.id">
                    <span class="studio-avatar studio-avatar--sm">{{ userInitials(user) }}</span>
                    {{ user.name }} {{ user.last_name }}
                    <button type="button" class="studio-chip-tag__x" @click="toggleCoAuthor(user)"
                            aria-label="حذف"><b-icon icon="x"/></button>
                  </span>
                </div>
                <div class="studio-search">
                  <b-icon icon="search" class="studio-search__icon"/>
                  <input v-model="coAuthorSearch" class="studio-search__input" placeholder="جستجوی کاربر..."
                         @keydown.enter.prevent="loadCoAuthorUsers">
                  <button type="button" class="studio-search__action" @click="loadCoAuthorUsers">
                    <b-spinner v-if="coAuthorLoading" small/>
                    <b-icon v-else icon="arrow-left-short"/>
                  </button>
                </div>
                <div class="studio-picklist studio-picklist--people">
                  <button type="button" v-for="user in coAuthorUsers" :key="'cu-' + user.id" class="studio-person"
                          :class="{ 'is-checked': isCoAuthor(user) }" @click="toggleCoAuthor(user)">
                    <span class="studio-avatar">{{ userInitials(user) }}</span>
                    <span class="studio-person__name">{{ user.name }} {{ user.last_name }}</span>
                    <b-icon :icon="isCoAuthor(user) ? 'check-circle-fill' : 'plus-circle'" class="studio-person__mark"/>
                  </button>
                  <p class="studio-picklist__empty" v-if="!coAuthorUsers.length && !coAuthorLoading">کاربری یافت نشد.</p>
                </div>
              </div>
            </section>
          </aside>
        </div>

        <div class="studio-actions studio-actions--single">
          <button type="submit" class="studio-primary-btn">
            <b-icon icon="check2-circle"/> تایید
          </button>
        </div>
      </b-form>
    </div>
  </div>
</template>
<script>
import router from '@/router';
import {mapGetters} from "vuex";
import category from "../product/category.vue";
import {required, numeric} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import NameAndLinkManager from "./FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "./FormItems/PublishedCheckbox.vue";
import SingleImage from "./FormItems/SingleImage.vue";
import RadioBox from "./FormItems/RadioBox.vue";
import FormInput from "./FormItems/FormInput.vue";
import FormTextArea from "./FormItems/FormTextArea.vue";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import AddIframeToEditor from "./FormItems/AddIframeToEditor";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import languageBox from "../Language/LanguageBox";
import {Vue2TinymceEditor} from "vue2-tinymce-editor";
import QrGenerator from "@/plugin/components/genralComponents/QrGenerator.vue";
import QuickCategoryCreate from "@/plugin/components/dashboard/product/QuickCategoryCreate.vue";
import FileManager from "@/plugin/views/dashboard/FileManager.vue";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import UserFilter2 from "@/plugin/components/dashboard/Filters/User/UserFilter2.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "CreateContentLayout",
  components: {
    UserFilter2,
    FileManager,
    QrGenerator,
    QuickCategoryCreate,
    category,
    FormGroup,
    AddIframeToEditor,
    FormErrorsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    SingleImage,
    RadioBox,
    FormInput,
    FormTextArea,
    languageBox,
    Vue2TinymceEditor,
    datePicker: VuePersianDatetimePicker,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      fields: [
        {key: "name", label: "کلمه کلیدی"},
        {key: "action", label: ""},
      ],
      form: {
        titleAndSlug: {name: "", link: ""},
        mainImage: [],
        content_type: '',
        selectedCategory: [],
        author_contributes: [],
        free: null,
        course_status: null,
        section_name: null,
        status: false,
        abstraction: "",
        body: "",
        keyWords: [],
        table: [],
        mainPreview: "",
        language_id: '',
        editor_mode: 0,
        created_at: null,
      },
      categorySearch: '',
      isMobileLayout: false,
      mobileLayoutQuery: null,
      keywordDraft: '',
      categoryIdsSnapshot: null,
      pendingCategoryAutoSelect: false,
      coAuthorSearch: '',
      coAuthorUsers: [],
      coAuthorLoading: false,
      content_typeList: [
        {name: "پست", id: '1'},
        {name: "برگه", id: '0'},
      ],
      defaultToolbar,
      showModal: false,
      selected_component_mode: null,
      selected_component_index: null,
      selected_component: {},
      editor_components: [
        {
          name: "m-slider-301",
          props: {
            autoPlay: {
              default: false,
            },
            autoPlayDuration: {
              default: 1000,
            },
            images: {
              type: 'Array',
              source: 'file-manager',
              default: [],
              sample: {
                value: "https://news-cdn.varzesh3.com/pictures/2026/01/26/A/5wasoss30.webp?w=350",
                alt: "1",
              }
            },
          }
        },
        {
          name: "m-slider-302",
          props: {
            swiperPerViewSM: {
              default: 2,
            },
            swiperPerViewMD: {
              default: 3,
            },
            swiperPerViewLG: {
              default: 4,
            },
            autoPlay: {
              default: false,
            },
            autoPlayDuration: {
              default: 1000,
            },
            images: {
              type: 'Array',
              source: 'file-manager',
              default: [],
              sample: {
                value: "https://news-cdn.varzesh3.com/pictures/2026/01/26/A/5wasoss30.webp?w=350",
                alt: "1",
              }
            },

          }
        },
        {
          name: "m-section-200",
          props: {
            imageBefore: {
              type: 'string',
              default: 'https://picsum.photos/1280/720'
            },
            imageAfter: {
              type: 'string',
              default: 'https://picsum.photos/1280/720'
            },
            direction: {
              type: 'string',
              default: 'horizontal',
              options: ['vertical', 'horizontal']
            },
            beforeText: {
              type: 'string',
              default: "قبل"
            },
            afterText: {
              type: 'string',
              default: "بعد"
            }
          },
        }
      ]
    };
  },
  validations: {
    form: {
      titleAndSlug: {name: {required}},
      selectedCategory: {required},
      content_type: {required},
      abstraction: {required},
      body: {required},
      language_id: {required},
      created_at: {},
      mainImage: {
        required: (value) => {

          return router.currentRoute.params.slug != undefined || value.length !== 0

        }
      }
    },
  },
  watch: {
    categories() {
      this.selectNewCategories()
    },
  },
  computed: {
    coAuthors() {
      return Array.isArray(this.form.author_contributes) ? this.form.author_contributes : []
    },
    flatCategoryList() {
      const list = []
      const walk = items => (items || []).forEach(item => {
        list.push(item)
        if (Array.isArray(item.children)) walk(item.children)
      })
      walk(this.categories)
      return list
    },
    categoryRows() {
      const rows = []
      const word = (this.categorySearch || '').trim()
      const walk = (items, depth) => {
        (items || []).forEach(item => {
          const hasChildren = Array.isArray(item.children) && item.children.length > 0
          if (!word || (item.name || '').indexOf(word) > -1) {
            rows.push({item, depth: word ? 0 : depth, hasChildren})
          }
          if (hasChildren) walk(item.children, depth + 1)
        })
      }
      walk(this.categories, 0)
      return rows
    },
    ...mapGetters({
      categories: "Category/getCategories",
    }),
  },
  methods: {
    onMainImagePicked(file) {
      // keep the preview when the picker moves between sidebar and title (breakpoint change)
      if (file instanceof Blob) this.form.mainPreview = URL.createObjectURL(file)
    },
    syncMobileLayout() {
      this.isMobileLayout = !!(this.mobileLayoutQuery && this.mobileLayoutQuery.matches)
    },
    addKeywords(text) {
      const words = String(text || '').split(/[,،\n]/).map(word => word.trim()).filter(Boolean)
      words.forEach(word => {
        if (this.form.keyWords.indexOf(word) === -1) {
          this.form.keyWords.push(word)
          this.form.table.push({name: word})
        }
      })
      this.keywordDraft = ''
    },
    onKeywordInput() {
      if (/[,،]/.test(this.keywordDraft)) this.addKeywords(this.keywordDraft)
    },
    onKeywordBackspace() {
      if (!this.keywordDraft && this.form.keyWords.length) this.removeKeyword(this.form.keyWords.length - 1)
    },
    removeKeyword(index) {
      const word = this.form.keyWords[index]
      this.form.keyWords.splice(index, 1)
      const tableIndex = this.form.table.findIndex(item => item && item.name === word)
      if (tableIndex > -1) this.form.table.splice(tableIndex, 1)
    },
    snapshotCategoryIds() {
      this.categoryIdsSnapshot = this.flatCategoryList.map(item => item.id)
    },
    onContentCategoryCreated() {
      this.pendingCategoryAutoSelect = true
      this.$bvModal.hide('create-content-category')
      this.categorySearch = ''
      this.selectNewCategories()
      this.$store.dispatch('Category/getDashboardCategories')
    },
    selectNewCategories() {
      if (!this.pendingCategoryAutoSelect || !Array.isArray(this.categoryIdsSnapshot)) return
      const known = this.categoryIdsSnapshot
      const added = this.flatCategoryList.filter(item => known.indexOf(item.id) === -1)
      if (!added.length) return
      added.forEach(item => {
        if (!this.isCategorySelected(item)) this.form.selectedCategory.push(item)
      })
      this.pendingCategoryAutoSelect = false
      this.categoryIdsSnapshot = null
      this.$v.form.selectedCategory.$touch()
    },
    setContentType(id) {
      this.form.content_type = id
      this.$v.form.content_type.$touch()
    },
    isCategorySelected(category) {
      return this.form.selectedCategory.some(item => item.id === category.id)
    },
    toggleCategory(category) {
      const index = this.form.selectedCategory.findIndex(item => item.id === category.id)
      if (index === -1) {
        this.form.selectedCategory.push(category)
      } else {
        this.form.selectedCategory.splice(index, 1)
      }
    },
    refreshCategories() {
      this.$store.dispatch("Category/getDashboardCategories");
    },
    userInitials(user) {
      const first = ((user && user.name) || '').trim().charAt(0)
      const last = ((user && user.last_name) || '').trim().charAt(0)
      return (first + (last ? '\u200c' + last : '')) || '?'
    },
    isCoAuthor(user) {
      return !!user && this.coAuthors.some(item => item && String(item.id) === String(user.id))
    },
    toggleCoAuthor(user) {
      if (!user) return
      const list = this.coAuthors
      const exists = this.isCoAuthor(user)
      this.$set(this.form, 'author_contributes', exists
          ? list.filter(item => !item || String(item.id) !== String(user.id))
          : [...list, user])
    },
    async loadCoAuthorUsers() {
      this.coAuthorLoading = true
      try {
        this.$store.commit("User/setFilters", {key: "role", value: [1, 2, 3, 4]});
        this.$store.commit('User/setFilters', {key: 'search', value: this.coAuthorSearch})
        const res = await this.$store.dispatch('User/getPersonsWithoutState', 1)
        this.coAuthorUsers = (res && res.data && res.data.data && res.data.data.data) || []
      } catch (e) {
        console.log(e)
      } finally {
        this.coAuthorLoading = false
      }
    },
    nowData() {
      const now = new Date();

      const date =
          now.getFullYear() + '-' +
          String(now.getMonth() + 1).padStart(2, '0') + '-' +
          String(now.getDate()).padStart(2, '0') + ' ' +
          String(now.getHours()).padStart(2, '0') + ':' +
          String(now.getMinutes()).padStart(2, '0') + ':' +
          String(now.getSeconds()).padStart(2, '0');
      return date
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    removeAmpOnEditor(content) {
      return content.replaceAll('&amp;', "&")
    },
    onSubmit() {
      if (this.invalid()) {
        this.form.body = this.form.body.replaceAll('v-resize', '').replaceAll('<iframe ', '<iframe v-resize ')
        this.form.body = this.removeAmpOnEditor(this.form.body)
        this.form.abstraction = this.removeAmpOnEditor(this.form.abstraction)
        const form = {title: this.form.titleAndSlug.name, slug: this.form.titleAndSlug.link, ...this.form};
        this.submitFunction(form);
      }
    },
    iframeHandlerFunction(iframe) {
      this.form.body += iframe;
    },
    async setContent() {
      let language_id = this.findAttributeOnSiteInfo('default_language')[0].id
      const routerslug = this.$route.params.slug;
      if (routerslug !== undefined) {
        this.form.titleAndSlug.link = routerslug;
        this.$store
            .dispatch("Content/getDashboardContent", this.form.titleAndSlug.link)
            .then(async (res) => {
              this.form.titleAndSlug.name = await res.title;
              this.form.id = await res.id;
              this.form.titleAndSlug.link = await res.slug;
              this.form.content_type = await res.content_type
              this.form.status = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.free = await res.free;
              this.form.course_status = await res.course_status;
              this.form.section_name = await res.section_name;
              this.form.author = await res.author;
              this.form.author_contributes = (await res.author_contributes) || [];
              this.form.description = await res.description;
              this.form.abstraction = await res.abstraction;
              this.form.created_at = await res.created_at;
              this.form.body = await res.body;
              this.form.editor_mode = await res.editor_mode ? true : false;
              language_id = await res.language_id;

              this.form.selectedCategory = []

              await res.category.forEach((category) => {
                this.form.selectedCategory.push(category)
              });

              document.getElementById(`item_${this.form.content_type}`).click();
              document.getElementById(`language_item_${language_id}`).click();
              this.form.keyWords = []
              this.form.table = []
              res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });
            })
            .catch((err) => {
              console.log(err);
            });
      } else {
        this.form.author = this.$store.getters['User/getProfile']
        document.getElementById(`language_item_${language_id}`).click();
      }
    },
    copyToClipBoard(value) {
      navigator.clipboard.writeText(value);
      toast('عملیات با موفقیت انجام شد', 'کپی شد.', 'success')
    },
    contentType() {
      return this.form.content_type == 1 ? 'SinglePost' : 'SinglePage'
    },
    handleEscape(event) {
      if (event.key === "Escape") {
        this.showModal = false;
      }
    },
    insertFileInEditor(fileUrl) {
      const editor = this.$refs.tinymceEditor.editor;
      if (!editor) return;

      // مثال: اگر فایل تصویر هست، تگ img اضافه کن
      const ext = fileUrl.split('.').pop().toLowerCase();
      let insertHtml = '';

      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) {
        insertHtml = `<img src="${fileUrl}" alt="تصویر"/>`;
      } else if (['mp4', 'webm', 'ogg'].includes(ext)) {
        insertHtml = `<video controls src="${fileUrl}"></video>`;
      } else {
        // فایل غیر قابل نمایش (مثلاً pdf، docx و...)
        insertHtml = `<a href="${fileUrl}" target="_blank">${fileUrl}</a>`;
      }

      editor.execCommand('mceInsertContent', false, insertHtml);
    },
    waitForTinyMCE() {
      const tryGetEditor = () => {
        const comp = this.$refs.tinymceEditor;
        if (!comp) return null;

        // حالت‌های مختلفی که ممکنه داشته باشه
        return comp.editor || (comp.getEditor && comp.getEditor()) || comp.tinymce || null;
      };

      const timer = setInterval(() => {
        const editor = tryGetEditor();

        if (editor && editor.on) {
          clearInterval(timer);

          // رویداد کلیک داخل iframe
          editor.on("click", this.onEditorClick);

          // اگر خواستی فقط وقتی فوکوس گرفت:
          // editor.on("focus", this.onEditorClick);
        }
      }, 100);

      // برای اینکه اگر یه وقت ادیتور بالا نیومد، forever loop نشه
      setTimeout(() => clearInterval(timer), 5000);
    },
    onEditorClick(e) {
      const el = e.target?.closest?.('[data-component="true"]');
      if (el) {
        this.selected_component_mode = el
        this.selected_component = JSON.parse(el.getAttribute('data-raw-data'))
        this.$refs['add-component'].show()
      }
    },
    resetModal() {
      this.selected_component = {}
    },
    detachTinyEvents() {
      const comp = this.$refs.tinymceEditor;
      const editor =
          comp?.editor || (comp?.getEditor && comp.getEditor()) || comp?.tinymce;

      if (editor && editor.off) {
        editor.off("click", this.onEditorClick);
      }
    },
    setValueOfImage(fileUrl) {
      let sample = Object.assign({}, this.selected_component.props[this.selected_component_index]['sample']);
      sample['image'] = fileUrl
      this.selected_component.props[this.selected_component_index]['default'].push(sample)
    },
    setModalItem(key) {
      this.selected_component_index = key
    },
    editorComponentHandler(event) {
      console.log('editorComponentHandler', event)
    },
    selectedComponentProps() {
      if (this.selected_component.length === 0) {
        return []
      }
      return this.selected_component?.props
    },
    camelTokKebab(str) {
      return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    },
    submitComponent() {
      let componentName = this.selected_component.name
      let componentProps = this.selected_component.props
      let componentRawJson = JSON.stringify(this.selected_component)
      let propsResult = ''

      Object.keys(componentProps).forEach((key) => {
        let value = componentProps[key]['default'];


        if (key === 'images') {
          let images = [];
          value.forEach(image => {
            images.push({
              value: image['image'],
              alt: image['alt']
            });
          });
          images = JSON.stringify(images, null, 2);

          propsResult += ` :${this.camelTokKebab(key)}='${images}' `;
        } else if (componentProps[key]['type'] == 'string' && key != 'images') {
          // از نام کلید واقعی استفاده کنید
          propsResult += ` ${this.camelTokKebab(key)}='${value}' `;
        } else {
          // از نام کلید واقعی استفاده کنید
          propsResult += ` :${this.camelTokKebab(key)}='${value}' `;
        }
      });

      let generateComponentId = generateHash()
      let componentResult = `<${componentName} id="editor-component-${generateComponentId}" ${propsResult}  data-component="true"  data-raw-data='${componentRawJson}'  >${componentName}</${componentName}>`;

      const editor = this.$refs.tinymceEditor.editor;
      if (!editor) return;


      if (this.selected_component_mode) {
        const editor = this.$refs.tinymceEditor.editor;
        const newNode = editor.dom.create('div', {}, componentResult).firstChild
        editor.dom.replace(newNode, this.selected_component_mode);
        this.selected_component_mode = null
      } else {
        editor.execCommand('mceInsertContent', false, componentResult);
        this.selected_component_mode = null
      }

      this.selected_component_mode = null

      this.$refs['add-component'].hide()

    },
    moveItem(arrayItem, index, mode = 'up') {

      if (mode === 'up') {
        if (index > 0) {
          arrayItem.splice(index - 1, 1, arrayItem.splice(index, 1, arrayItem[index - 1])[0]);
        }
      }
      if (mode === 'down') {
        if (index < arrayItem.length - 1) {
          arrayItem.splice(index + 1, 1, arrayItem.splice(index, 1, arrayItem[index + 1])[0]);
        }

      }
    },
    removeItem(arrayItem, index,) {
      arrayItem.splice(index, 1)
    },
    setAuthor(item) {
      this.form.author = item
    },
    setAuthorContribute(items) {
      this.$set(this.form, 'author_contributes', Array.isArray(items) ? [...items] : [])
    }
  },
  created() {
    if (typeof window !== 'undefined' && window.matchMedia) {
      this.mobileLayoutQuery = window.matchMedia('(max-width: 991.98px)')
      this.syncMobileLayout()
      if (this.mobileLayoutQuery.addEventListener) this.mobileLayoutQuery.addEventListener('change', this.syncMobileLayout)
      else if (this.mobileLayoutQuery.addListener) this.mobileLayoutQuery.addListener(this.syncMobileLayout)
    }
  },
  async mounted() {
    await this.$store.dispatch("Category/getDashboardCategories");

    this.form.created_at = this.nowData()
    this.loadCoAuthorUsers()

    setTimeout(async () => {
      await this.setContent()
    }, 500)
    document.addEventListener("keydown", this.handleEscape);


    this.waitForTinyMCE()

    this.$store.dispatch("Category/getDashboardCategories").then(() => {
      setTimeout(() => {
        this.setContent();
      }, 500);
    });

  },
  beforeDestroy() {
    if (this.mobileLayoutQuery) {
      if (this.mobileLayoutQuery.removeEventListener) this.mobileLayoutQuery.removeEventListener('change', this.syncMobileLayout)
      else if (this.mobileLayoutQuery.removeListener) this.mobileLayoutQuery.removeListener(this.syncMobileLayout)
    }
    document.removeEventListener("keydown", this.handleEscape);
  },
};
</script>
<style scoped>


.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}


.content-studio {
  --ink: #1e1e1e;
  --ink-soft: #424242;
  --muted: #6b6b6b;
  --line: rgba(30, 30, 30, 0.1);
  --surface: rgba(255, 255, 255, 0.94);
  --dash-primary: var(--primary, #eb3d60);
  --dash-primary-soft: rgba(235, 61, 96, 0.12);
  --dash-secondary: var(--secondary, #1e1e1e);
  --accent-deep: #d12d50;
  --shadow: 0 14px 40px rgba(30, 30, 30, 0.07);
  position: relative;
  min-height: 100%;
  padding: 0 0 5.5rem;
  color: var(--ink);
  background:
      radial-gradient(circle at 10% 0%, rgba(235, 61, 96, 0.1), transparent 36%),
      radial-gradient(circle at 92% 8%, rgba(30, 30, 30, 0.05), transparent 30%),
      linear-gradient(180deg, #f6f6f8 0%, #fafafa 52%, #f3f3f5 100%);
  border-radius: 18px;
}

.content-studio__ambient {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
      linear-gradient(rgba(30, 30, 30, 0.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(30, 30, 30, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.28), transparent 80%);
}

.content-studio__shell {
  position: relative;
  z-index: 1;
  padding: 0.75rem;
}

.studio-topbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
  padding: 0.35rem 0.25rem 0;
}

.studio-eyebrow {
  margin: 0 0 0.35rem;
  color: var(--dash-primary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.studio-title {
  margin: 0;
  font-size: clamp(1.45rem, 2.4vw, 2rem);
  font-weight: 800;
  color: var(--ink);
}

.studio-topbar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.studio-chip,
.studio-ghost-btn,
.studio-primary-btn {
  border: 0;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.studio-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  font-size: 0.86rem;
  font-weight: 600;
  text-decoration: none;
}

.studio-chip:hover,
.studio-ghost-btn:hover,
.studio-primary-btn:hover {
  transform: translateY(-1px);
  text-decoration: none;
}

.studio-form {
  display: grid;
  gap: 0.75rem;
}

.studio-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 0.75rem;
  align-items: start;
}

.studio-main,
.studio-side {
  display: grid;
  gap: 0.75rem;
  min-width: 0;
}

.studio-side {
  position: sticky;
  top: 0.75rem;
}

.studio-panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: var(--shadow);
  overflow: hidden;
}

.studio-panel__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--line);
  background:
      linear-gradient(120deg, rgba(235, 61, 96, 0.08), transparent 46%),
      #fff;
}

.studio-panel__title {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 800;
  color: var(--ink);
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.studio-panel__title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 10px;
  background: rgba(235, 61, 96, 0.12);
  color: var(--dash-primary);
  font-size: 0.95rem;
  flex: 0 0 auto;
}

.studio-panel__hint {
  margin: 0.35rem 0 0;
  color: var(--muted);
  font-size: 0.86rem;
  line-height: 1.6;
}

.studio-step {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: var(--dash-secondary);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
}

.studio-panel__body {
  padding: 0.9rem 1rem 1rem;
}

.studio-label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.55rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.studio-status-chip {
  display: flex;
  align-items: center;
  padding: 0.55rem 0.8rem;
  border-radius: 12px;
  background: var(--dash-primary-soft);
}

.studio-status-chip >>> .form-group,
.studio-status-chip >>> .custom-control {
  margin-bottom: 0;
}

.studio-ghost-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
  justify-content: center;
  padding: 0.6rem 0.9rem;
  border-radius: 12px;
  background: #f6f6f7;
  border: 1px solid var(--line);
  color: var(--ink-soft);
  font-weight: 700;
}

.studio-qr-card {
  display: flex;
  justify-content: center;
  padding: 0.75rem;
  border-radius: 14px;
  border: 1px dashed var(--line);
  background: #fff;
}

.studio-side__boxes >>> .col-md-6,
.studio-side__boxes >>> .col-lg-6 {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0;
}

.studio-side__boxes >>> .alert {
  background: #fafafb;
  border: 1px solid var(--line);
  border-radius: 12px;
  color: var(--ink);
}

.studio-side__boxes >>> .overflow_div {
  height: auto !important;
  max-height: 300px;
  overflow-y: auto;
}

.studio-editor {
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid rgba(30, 30, 30, 0.12);
  background: #fff;
}

.studio-editor__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  background: linear-gradient(180deg, #f7f7f8, #efeff1);
  border-bottom: 1px solid rgba(30, 30, 30, 0.1);
}

.studio-editor__bar-label {
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--ink-soft);
}

.studio-editor__bar >>> .iframe-editor-tool {
  flex: 1 1 280px;
}

.studio-editor__canvas >>> .tox-tinymce {
  border: 0 !important;
  border-radius: 0 !important;
}

.content-editor >>> .form-group {
  margin-bottom: 0;
}

.content-editor__tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem;
  border-bottom: 1px solid var(--line);
}

.content-editor__tools >>> .btn {
  margin: 0 !important;
  border-radius: 999px;
}

.content-keywords >>> .row.mt-5 {
  margin-top: 0 !important;
}

.studio-actions {
  position: sticky;
  bottom: 0.75rem;
  z-index: 20;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  padding: 0.9rem;
  border-radius: 20px;
  background: rgba(30, 30, 30, 0.94);
  box-shadow: 0 18px 40px rgba(30, 30, 30, 0.28);
  backdrop-filter: blur(12px);
}

.studio-primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 50px;
  border-radius: 999px;
  font-weight: 800;
  background: var(--dash-primary);
  color: #fff;
  box-shadow: 0 10px 24px rgba(235, 61, 96, 0.32);
}

.studio-primary-btn:hover {
  background: var(--accent-deep);
}

@media (max-width: 1199.98px) {
  .studio-layout {
    grid-template-columns: minmax(0, 1fr) 300px;
  }
}

@media (max-width: 991.98px) {
  .studio-layout {
    grid-template-columns: 1fr;
  }

  .studio-side {
    position: static;
  }
}

@media (max-width: 767.98px) {
  .content-studio__shell {
    padding: 0.4rem;
  }

  .studio-panel__body {
    padding: 0.75rem;
  }
}

/* ---- publish status ---- */
.studio-status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border-radius: 14px;
  background: #f6f6f8;
  border: 1px solid var(--line);
  transition: background 0.2s ease, border-color 0.2s ease;
}

.studio-status-row.is-on {
  background: var(--dash-primary-soft);
  border-color: rgba(235, 61, 96, 0.25);
}

.studio-status-row__text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.studio-status-row__label {
  font-weight: 700;
  font-size: 0.85rem;
  color: var(--ink-soft);
  white-space: nowrap;
}

.studio-status-row__state {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #8a8a96;
  white-space: nowrap;
}

.studio-status-row.is-on .studio-status-row__state {
  color: var(--dash-primary);
}

.studio-status-row__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.studio-switch {
  position: relative;
  flex: 0 0 auto;
  width: 46px;
  height: 26px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: #d4d4da;
  cursor: pointer;
  transition: background 0.2s ease;
}

.studio-switch.is-on {
  background: var(--dash-primary);
}

.studio-switch__knob {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
}

.studio-switch.is-on .studio-switch__knob {
  transform: translateX(-20px);
}

.studio-switch:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(235, 61, 96, 0.2);
}

/* ---- content type segmented ---- */
.studio-segment {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: #f3f3f5;
  border: 1px solid var(--line);
}

.studio-segment__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.4rem 0.5rem;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--ink-soft);
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.studio-segment__btn.is-active {
  background: #fff;
  color: var(--dash-primary);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.studio-field-error {
  display: block;
  margin-top: 0.35rem;
  color: #dc3545;
  font-weight: 600;
}

/* ---- chips / search / picklists ---- */
.studio-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.6rem;
}

.studio-chip-tag,
.studio-person-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.2rem 0.35rem 0.2rem 0.6rem;
  border-radius: 999px;
  background: var(--dash-primary-soft);
  color: var(--dash-primary);
  font-size: 0.78rem;
  font-weight: 700;
}

.studio-person-chip {
  padding-right: 0.2rem;
}

.studio-chip-tag__x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(235, 61, 96, 0.15);
  color: var(--dash-primary);
  cursor: pointer;
}

.studio-chip-tag__x:hover {
  background: var(--dash-primary);
  color: #fff;
}

.studio-search {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.studio-search__icon {
  position: absolute;
  right: 0.7rem;
  color: #9a9aa5;
  pointer-events: none;
}

.studio-search__input {
  width: 100%;
  height: 36px;
  padding: 0 2.1rem 0 2.4rem;
  border: 1px solid var(--line);
  border-radius: 11px;
  background: #fff;
  font-size: 0.82rem;
  outline: none;
}

.studio-search__input:focus {
  border-color: var(--dash-primary);
  box-shadow: 0 0 0 3px rgba(235, 61, 96, 0.12);
}

.studio-search__action {
  position: absolute;
  left: 0.3rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: var(--dash-primary-soft);
  color: var(--dash-primary);
  cursor: pointer;
}

.studio-picklist {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 0.3rem;
  background: #fcfcfd;
}

.studio-picklist__empty {
  margin: 0;
  padding: 0.8rem;
  text-align: center;
  font-size: 0.8rem;
  color: #9a9aa5;
}

.studio-pick {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  padding: 0.4rem 0.6rem;
  border-radius: 9px;
  cursor: pointer;
  font-size: 0.84rem;
  color: var(--ink-soft);
}

.studio-pick:hover {
  background: rgba(235, 61, 96, 0.06);
}

.studio-pick.is-checked {
  color: var(--dash-primary);
  font-weight: 700;
}

.studio-pick__check {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.studio-pick__box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border: 1.5px solid #cfcfd6;
  border-radius: 6px;
  background: #fff;
  color: transparent;
  font-size: 0.9rem;
  transition: all 0.15s ease;
}

.studio-pick.is-checked .studio-pick__box {
  border-color: var(--dash-primary);
  background: var(--dash-primary);
  color: #fff;
}

.studio-pick__check:focus + .studio-pick__box {
  box-shadow: 0 0 0 3px rgba(235, 61, 96, 0.18);
}

.studio-pick__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.studio-pick__sub {
  font-size: 0.68rem;
  font-weight: 700;
  color: var(--dash-primary);
  background: rgba(235, 61, 96, 0.1);
  border-radius: 999px;
  padding: 0.05rem 0.45rem;
}

.studio-person {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  padding: 0.4rem 0.5rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  text-align: right;
  color: var(--ink-soft);
  font-size: 0.84rem;
  cursor: pointer;
}

.studio-person:hover {
  background: rgba(235, 61, 96, 0.06);
}

.studio-person.is-checked {
  background: var(--dash-primary-soft);
  color: var(--dash-primary);
  font-weight: 700;
}

.studio-person__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.studio-person__mark {
  flex: 0 0 auto;
  color: #b8b8c2;
}

.studio-person.is-checked .studio-person__mark {
  color: var(--dash-primary);
}

.studio-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #eb3d60, #ff8a9f);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 800;
}

.studio-avatar--sm {
  width: 20px;
  height: 20px;
  font-size: 0.6rem;
}

.studio-image >>> .single-image {
  object-fit: cover !important;
}

.studio-head-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  align-self: center;
  padding: 0.3rem 0.7rem;
  border: 1px solid rgba(235, 61, 96, 0.25);
  border-radius: 999px;
  background: #fff;
  color: var(--dash-primary);
  font-size: 0.76rem;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.studio-head-btn:hover {
  background: var(--dash-primary);
  color: #fff;
}

.studio-category-modal__hint {
  margin-bottom: 1rem;
  color: #6b6b6b;
  font-size: 0.85rem;
}

.kw-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  min-height: 42px;
  padding: 0.35rem 0.5rem;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
  cursor: text;
}

.kw-input:focus-within {
  border-color: var(--dash-primary);
  box-shadow: 0 0 0 3px rgba(235, 61, 96, 0.12);
}

.kw-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.15rem 0.3rem 0.15rem 0.6rem;
  border-radius: 999px;
  background: var(--dash-primary-soft);
  color: var(--dash-primary);
  font-size: 0.78rem;
  font-weight: 700;
}

.kw-chip__x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(235, 61, 96, 0.15);
  color: var(--dash-primary);
  cursor: pointer;
}

.kw-chip__x:hover {
  background: var(--dash-primary);
  color: #fff;
}

.kw-input__field {
  flex: 1 1 140px;
  min-width: 120px;
  height: 28px;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 0.85rem;
}

.kw-help {
  display: block;
  margin-top: 0.35rem;
  color: #9a9aa5;
  font-size: 0.74rem;
}

.studio-basics--with-thumb {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.studio-basics__fields {
  flex: 1 1 auto;
  min-width: 0;
}

.studio-title-thumb {
  flex: 0 0 auto;
  width: 84px;
}

.studio-title-thumb >>> .single-image-picker--empty,
.studio-title-thumb >>> .single-image {
  width: 84px !important;
  height: 84px !important;
  border-radius: 14px;
}

.studio-title-thumb >>> .single-image-picker__icon {
  font-size: 1.3rem;
}

.studio-title-thumb >>> .single-image-picker__text {
  font-size: 0.68rem;
}
</style>

<style>
/* publish date picker of the content form is appended to <body> (append-to="body");
   keep its popup above the editor toolbar and sticky studio elements */
body > .vpd-wrapper {
  z-index: 3000 !important;
}
</style>
